/**
 * Collection : filtres Search & Discovery dans une modale + bouton filtre header (mobile).
 */
(function () {
  'use strict';

  var DESKTOP_MIN = 769;
  var placeholder = null;

  function isDesktop() {
    return window.matchMedia('(min-width: ' + DESKTOP_MIN + 'px)').matches;
  }

  function getSidebar() {
    return document.getElementById('CollectionSidebar');
  }

  function getModalBody() {
    return document.getElementById('collection-filters-modal-body');
  }

  function getModalRoot() {
    return document.getElementById('collection-filters-modal');
  }

  function getOpenButtons() {
    return document.querySelectorAll(
      '#collection-open-filters, #collection-open-filters-head, #collection-open-filters-quick'
    );
  }

  function ensurePlaceholder() {
    var sidebar = getSidebar();
    if (!sidebar || !sidebar.parentNode) return;
    if (placeholder && placeholder.parentNode) return;
    placeholder = document.createElement('div');
    placeholder.id = 'CollectionSidebarPlaceholder';
    placeholder.setAttribute('aria-hidden', 'true');
    placeholder.style.display = 'none';
    sidebar.parentNode.insertBefore(placeholder, sidebar);
  }

  function moveSidebarToModal() {
    var sidebar = getSidebar();
    var body = getModalBody();
    if (!sidebar || !body) return;
    ensurePlaceholder();

    var root = getModalRoot();

    if (isDesktop()) {
      document.body.classList.add('collection-filters-desktop-modal');
      body.appendChild(sidebar);
      syncTriggerVisibility();
      return;
    }

    document.body.classList.remove('collection-filters-desktop-modal');
    if (root && root.classList.contains('is-open')) {
      body.appendChild(sidebar);
    } else if (sidebar.parentNode === body && placeholder && placeholder.parentNode) {
      placeholder.parentNode.insertBefore(sidebar, placeholder);
    }
    syncTriggerVisibility();
  }

  function syncTriggerVisibility() {
    var sidebar = getSidebar();
    var hasFilters = sidebar && sidebar.querySelector('.filter-form');
    var showDesktop = isDesktop() && hasFilters;
    var showMobile = !isDesktop() && hasFilters;

    var btnBar = document.getElementById('collection-open-filters');
    if (btnBar) {
      if (isDesktop()) {
        btnBar.style.display = showDesktop ? 'inline-flex' : 'none';
      } else {
        btnBar.style.display = 'none';
      }
      btnBar.setAttribute('aria-hidden', showDesktop ? 'false' : 'true');
    }

    var btnHead = document.getElementById('collection-open-filters-head');
    if (btnHead) {
      if (!isDesktop()) {
        btnHead.style.display = showMobile ? 'inline-flex' : 'none';
      } else {
        btnHead.style.display = 'none';
      }
      btnHead.setAttribute('aria-hidden', showMobile ? 'false' : 'true');
    }
  }

  function syncExpanded(open) {
    getOpenButtons().forEach(function (b) {
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function countActiveFilters() {
    var sidebar = getSidebar();
    if (!sidebar) return 0;
    return sidebar.querySelectorAll('.tag-list--active-tags .tag--remove').length;
  }

  function syncFilterBadge() {
    var n = countActiveFilters();
    var label = n > 0 ? 'Filtres, ' + n + (n > 1 ? ' actifs' : ' actif') : 'Filtres';
    getOpenButtons().forEach(function (btn) {
      var badge = btn.querySelector('.as-filters-btn__count');
      var hidden = btn.querySelector('.visually-hidden');
      if (badge) {
        if (n > 0) {
          badge.hidden = false;
          badge.textContent = n > 9 ? '9+' : String(n);
        } else {
          badge.hidden = true;
          badge.textContent = '';
        }
      }
      if (hidden) hidden.textContent = label;
      btn.classList.toggle('is-active', n > 0);
    });
  }

  function getFocusable(root) {
    return Array.prototype.slice.call(
      root.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter(function (el) {
      return !el.hidden && (el.offsetParent !== null || el.getClientRects().length > 0);
    });
  }

  var lastOpener = null;

  function trapFocus(e) {
    var root = getModalRoot();
    if (!root || !root.classList.contains('is-open')) return;
    if (e.key === 'Escape') {
      e.preventDefault();
      closeModal();
      return;
    }
    if (e.key !== 'Tab') return;
    var items = getFocusable(root);
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function openModal() {
    var root = getModalRoot();
    if (!root) return;
    if (document.activeElement && document.activeElement !== document.body) {
      lastOpener = document.activeElement;
    }
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('collection-filters-modal-open');
    syncExpanded(true);
    moveSidebarToModal();
    syncFilterBadge();
    if (typeof window.LovenUpdateFilterModalFooter === 'function') {
      window.LovenUpdateFilterModalFooter();
    }
    var closeBtn = root.querySelector('.collection-filters-modal__close');
    if (closeBtn) {
      setTimeout(function () {
        closeBtn.focus();
      }, 50);
    }
  }

  function closeModal() {
    var root = getModalRoot();
    if (!root) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('collection-filters-modal-open');
    syncExpanded(false);
    moveSidebarToModal();
    /* Love'nSpa 15/10/2026 : collection-grid-page.js relance ici le chargement de la grille et de la carte. */
    document.dispatchEvent(new CustomEvent('loven:filters-modal-closed'));
    if (lastOpener && typeof lastOpener.focus === 'function') {
      lastOpener.focus();
    }
  }

  window.LovenCloseCollectionFiltersModal = closeModal;

  function bindModalUi() {
    if (window.__lovenCollectionFiltersModalBound) return;
    window.__lovenCollectionFiltersModalBound = true;
    var root = getModalRoot();
    var btns = getOpenButtons();
    if (!root || !btns.length) return;

    btns.forEach(function (openBtn) {
      openBtn.addEventListener('click', function (e) {
        e.preventDefault();
        openModal();
      });
    });

    root.querySelectorAll('[data-collection-filters-close]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        closeModal();
      });
    });

    document.addEventListener('keydown', trapFocus);
  }

  function init() {
    if (!getModalBody()) return;
    bindModalUi();
    moveSidebarToModal();
    syncFilterBadge();

    window.addEventListener('resize', debounceResize(moveSidebarToModal));
  }

  function debounceResize(fn) {
    if (window.theme && theme.utils && theme.utils.debounce) {
      return theme.utils.debounce(200, fn);
    }
    var t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, 200);
    };
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('collection:reloaded', function () {
    var root = getModalRoot();
    var keepOpen = !!(root && root.classList.contains('is-open'));
    var body = getModalBody();
    if (body) {
      body.querySelectorAll('#CollectionSidebar').forEach(function (node) {
        node.remove();
      });
    }
    placeholder = null;
    if (keepOpen && root) {
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      document.body.classList.add('collection-filters-modal-open');
    }
    moveSidebarToModal();
    syncTriggerVisibility();
    syncFilterBadge();
    if (keepOpen && typeof window.LovenUpdateFilterModalFooter === 'function') {
      window.LovenUpdateFilterModalFooter();
    }
  });
})();
